import queryString from 'query-string';

export const getParsedQueryString = urlQueryString => {
	if (!urlQueryString) {
		return {};
	}
	const parsed = queryString.parse(urlQueryString);
	return parsed || {};
};
